import { createFileRoute } from '@tanstack/react-router'
import { EventDetailPage } from '@/pages/event-detail'

export const Route = createFileRoute('/_authenticated/events/$eventId')({
  component: EventDetailPage,
})
